import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

const TicketQuickPreviewDialog = ({ open, ticket, onClose, isRTL }) => {
  const { t } = useTranslation();

  if (!ticket) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      dir={isRTL ? "rtl" : "ltr"}
    >
      <DialogTitle>
        #{ticket.ticket_id} — {ticket.title}
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="body1" sx={{ whiteSpace: "pre-wrap" }}>
          {ticket.message || "—"}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("common.cancel")}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default TicketQuickPreviewDialog;
